import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, MessageCircle } from 'lucide-react';
import { siteInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#004534] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold">MVP LAB</h3>
            <p className="text-white/70 leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex gap-4">
              <a
                href={siteInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-300"
              >
                <Instagram size={20} />
              </a>
              <a
                href={siteInfo.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#D3FF62] hover:text-[#004534] transition-all duration-300"
              >
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/venues" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Our Venues
              </Link>
              <Link to="/activities" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Activities
              </Link>
              <Link to="/communities" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Join Community
              </Link>
              <Link to="/events" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Events
              </Link>
              <Link to="/book" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Book Now
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Our Services</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/activities#padel" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Padel Courts
              </Link>
              <Link to="/activities#football" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Football Pitches
              </Link>
              <Link to="/activities#yoga" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Yoga & Pilates
              </Link>
              <Link to="/activities#recovery" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Recovery Zone
              </Link>
              <Link to="/activities#birthday" className="text-white/70 hover:text-[#D3FF62] transition-colors">
                Birthday Parties
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="text-lg font-semibold">Contact Us</h4>
            <div className="space-y-4">
              <a
                href={siteInfo.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-white/70 hover:text-[#D3FF62] transition-colors"
              >
                <MapPin size={20} className="mt-1 flex-shrink-0" />
                <span>{siteInfo.address}</span>
              </a>
              <a
                href={`tel:${siteInfo.phone}`}
                className="flex items-center gap-3 text-white/70 hover:text-[#D3FF62] transition-colors"
              >
                <Phone size={20} />
                <span>{siteInfo.phone}</span>
              </a>
              <a
                href={`mailto:${siteInfo.email}`}
                className="flex items-center gap-3 text-white/70 hover:text-[#D3FF62] transition-colors"
              >
                <Mail size={20} />
                <span>{siteInfo.email}</span>
              </a>
            </div>

            {/* App Download */}
            <div className="pt-4">
              <p className="text-sm text-white/50 mb-3">Download our app</p>
              <div className="flex gap-3">
                <a href={siteInfo.appStoreUrl} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676c375eb9400bc1546554e1_image%204.avif"
                    alt="Download MVP LAB on App Store - Indoor Sports Booking Dubai"
                    className="h-10 hover:opacity-80 transition-opacity"
                  />
                </a>
                <a href={siteInfo.playStoreUrl} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cdn.prod.website-files.com/676bbacea7c0ee9345daee2f/676c375e617314e296550298_image%203.avif"
                    alt="Get MVP LAB on Google Play - Indoor Sports Booking Dubai"
                    className="h-10 hover:opacity-80 transition-opacity"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} MVP LAB. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/" className="text-white/50 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/" className="text-white/50 hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
